import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/regenerator/index.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import o, { Component as h } from "react";
import { createPortal as y } from "react-dom";
import a from "imagesloaded";
import s from "prop-types";
var u = !!(typeof window < "u" && window.document && window.document.createElement);
var r = /*#__PURE__*/function (_h) {
  function r(e) {
    var _this;
    _classCallCheck(this, r);
    _this = _callSuper(this, r, [e]), _this.state = {
      flickityReady: !1,
      flickityCreated: !1,
      cellCount: 0
    }, _this.carousel = null, _this.flkty = null;
    return _this;
  }
  _inherits(r, _h);
  return _createClass(r, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(e, t) {
      var _this2 = this;
      if (!this.flkty) return;
      var _this$props = this.props,
        i = _this$props.children,
        _this$props$options = _this$props.options,
        l = _this$props$options.draggable,
        n = _this$props$options.initialIndex,
        c = _this$props.reloadOnUpdate,
        d = _this$props.disableImagesLoaded,
        f = this.state.flickityReady;
      if (c || !t.flickityReady && f) {
        var p = this.flkty.isActive;
        this.flkty.deactivate(), this.flkty.selectedIndex = n || 0, this.flkty.options.draggable = l === void 0 ? i ? i.length > 1 : !1 : l, p && this.flkty.activate(), !d && this.carousel && a(this.carousel, function () {
          _this2.flkty.reloadCells();
        });
      } else this.flkty.reloadCells();
    }
  }, {
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var e, _this$props2, t, i;
        return _regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(!u || !this.carousel)) {
                _context.next = 1;
                break;
              }
              return _context.abrupt("return", null);
            case 1:
              _context.next = 2;
              return import("flickity");
            case 2:
              e = _context.sent.default;
              _this$props2 = this.props;
              t = _this$props2.flickityRef;
              i = _this$props2.options;
              this.flkty = new e(this.carousel, i), t && t(this.flkty), this.props.static ? this.setReady() : this.setState({
                flickityCreated: !0
              });
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }
      return componentDidMount;
    }()
  }, {
    key: "setReady",
    value: function setReady() {
      var _this3 = this;
      if (this.state.flickityReady) return;
      var e = function e() {
        return _this3.setState({
          flickityReady: !0
        });
      };
      this.props.disableImagesLoaded ? e() : a(this.carousel, e);
    }
  }, {
    key: "renderPortal",
    value: function renderPortal() {
      var _this4 = this;
      if (!this.carousel) return null;
      var e = this.carousel.querySelector(".flickity-slider");
      if (e) {
        var t = y(this.props.children, e);
        return setTimeout(function () {
          return _this4.setReady();
        }, 0), t;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;
      return o.createElement(this.props.elementType, {
        className: this.props.className,
        ref: function ref(e) {
          _this5.carousel = e;
        }
      }, this.props.static ? this.props.children : this.renderPortal());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(e, t) {
      var i = o.Children.count(e.children);
      return i !== t.cellCount ? {
        flickityReady: !1,
        cellCount: i
      } : null;
    }
  }]);
}(h);
r.propTypes = {
  children: s.array,
  className: s.string,
  disableImagesLoaded: s.bool,
  elementType: s.string,
  flickityRef: s.func,
  options: s.object,
  reloadOnUpdate: s.bool,
  static: s.bool
};
r.defaultProps = {
  className: "",
  disableImagesLoaded: !1,
  elementType: "div",
  options: {},
  reloadOnUpdate: !1,
  static: !1
};
export { r as default };